var render = function render(_c,_vm){return _c('mm-alert',{key:"complete",staticClass:"order-detail-tips",attrs:{"type":"success","show-icon":"","closable":false}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('order.complete'),expression:"'order.complete'"}],attrs:{"slot":"title"},slot:"title"})])
}
var staticRenderFns = []

export { render, staticRenderFns }